import { useState } from 'react'
import {
  acceptAnalyticsConsent,
  getAnalyticsConsentStatus,
  rejectAnalyticsConsent,
} from '@/features/privacy/consent'

type ConsentBannerProps = {
  onOpenCookieSettings: () => void
}

export function ConsentBanner({ onOpenCookieSettings }: ConsentBannerProps) {
  const [status, setStatus] = useState(getAnalyticsConsentStatus())

  if (status !== 'unset') return null

  const onAccept = () => {
    acceptAnalyticsConsent()
    setStatus('accepted')
  }

  const onReject = () => {
    rejectAnalyticsConsent()
    setStatus('rejected')
  }

  return (
    <section
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-3xl rounded-[1.75rem] border border-edge/70 bg-surface p-4 shadow-panel sm:p-5"
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="min-w-0 space-y-1.5">
          <p className="eyebrow text-accent">Privacy Controls</p>
          <p className="text-sm leading-relaxed text-primary">
            We use optional analytics cookies to understand anonymous traffic and improve the
            product. You can accept, reject, or change this later in Privacy settings.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2 md:shrink-0 md:justify-end">
          <button type="button" onClick={onOpenCookieSettings} className="pill">
            Cookie settings
          </button>
          <button type="button" onClick={onReject} className="pill">
            Reject analytics
          </button>
          <button type="button" onClick={onAccept} className="pill-solid">
            Accept analytics
          </button>
        </div>
      </div>
    </section>
  )
}
